import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ControlValueAccessor } from '@angular/forms';

@Directive()
export class PickerDirective implements ControlValueAccessor {
    @Input() multiple: boolean;
    @Input() required: boolean;
    disabled: boolean;
    @Input() readonly: boolean;
    @Input() placeholder: string;
    @Input() value: any;
    @Input() exclude: any[];
    @Output() valueChanged = new EventEmitter<any>();
    @Input() hoverable = true;

    constructor(public dialog: MatDialog) {}

    writeValue(value: any) {
        if (value !== undefined) {
            this.value = value;
        }
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
        this.valueChanged.emit(this.value);
    }

    registerOnTouched() {
        /* Form control touched handler */
    }

    propagateChange = (_: any) => {
        // ControlValueAccessor callback placeholder
    };

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }
}
